import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import * as actions from "../redux/DashboardAction";
import { DashboardList } from "./dashboardList";
import { InboxDetail } from "./inboxDetail";

export const Dashboard = () => {
  const { inboxId } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.getDashboard({ action: "memberdashboard" }));
  }, []);

  return (
    <div className="d-flex flex-column align-items-stretch justify-content-center">
      {inboxId ? <InboxDetail /> : <DashboardList />}
    </div>
  );
};
